import type {
  ListDefinition,
  ListDetail,
  ListMaterializeResult,
  ListPreviewResult,
  ListSummary,
  NewListInput,
  Paginated,
  UpdateListInput,
} from '@fc/core'
import { apiFetch } from './api'

export type {
  ListDefinition,
  ListDetail,
  ListMaterializeResult,
  ListPreviewResult,
  ListRule,
  ListRuleGroup,
  ListSummary,
} from '@fc/core'

export const listLists = async (): Promise<ListSummary[]> => {
  const data = await apiFetch<Paginated<ListSummary>>('/lists')
  return data.items
}

export const getList = (id: string): Promise<ListDetail> => apiFetch<ListDetail>(`/lists/${id}`)

export const createList = (input: NewListInput): Promise<ListDetail> =>
  apiFetch<ListDetail>('/lists', { method: 'POST', body: JSON.stringify(input) })

export const updateList = (id: string, input: UpdateListInput): Promise<ListDetail> =>
  apiFetch<ListDetail>(`/lists/${id}`, { method: 'PATCH', body: JSON.stringify(input) })

export const deleteList = (id: string): Promise<void> =>
  apiFetch<void>(`/lists/${id}`, { method: 'DELETE' })

/**
 * Preview a list's matches. Pass an ad-hoc `definition` for a live builder
 * preview, or omit it to evaluate the stored definition.
 */
export const previewList = (id: string, definition?: ListDefinition): Promise<ListPreviewResult> =>
  apiFetch<ListPreviewResult>(`/lists/${id}/preview`, {
    method: 'POST',
    body: JSON.stringify(definition ? { definition } : {}),
  })

export const materializeList = (id: string): Promise<ListMaterializeResult> =>
  apiFetch<ListMaterializeResult>(`/lists/${id}/materialize`, { method: 'POST' })
